import React from 'react'

import { bemJoin } from 'bem-join'
import { DOCTypes, Document } from 'component-library-next'

import { useIntl } from '@app/intl/Intl'
import { Button } from '@app/lib/inputs/Button/Button'
import { UploadIconButton } from '@app/lib/inputs/UploadIconButton/uploadIconButton'
import { Text } from '@app/lib/typography/Text/Text'
import { InvoicingEndgameSelect } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingFinalizeSection/InvoicingEndgameSelect/InvoicingEndgameSelect'

type InvoicingFinalizeSectionProps = {
  files: File[]
  onFileUpload: () => void
  onFileRemove: (fileIndex: number) => void
  isSubmitting: boolean
}

export const InvoicingFinalizeSection = ({
  files,
  onFileUpload,
  onFileRemove,
  isSubmitting
}: InvoicingFinalizeSectionProps) => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()

  return (
    <div className={b('section')}>
      <div className={b('fields')}>
        <div className={b('upload-field')}>
          <Text size={'sm'}>
            {formatMessage({ id: 'CourtCases.Invoicing.Upload.FinalDocument' })}
          </Text>
          {files.length ? (
            files.map((file, index) => (
              <Document
                name={file.name}
                fileFormat={file.type as DOCTypes}
                onRemove={() => onFileRemove(index)}
              />
            ))
          ) : (
            <UploadIconButton onFileUpload={onFileUpload} />
          )}
        </div>
        <InvoicingEndgameSelect />
        <Button
          type='submit'
          color={'secondary'}
          variant={'solid'}
          size={'lg'}
          className={b('submit')}
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          {formatMessage({ id: 'CourtCases.Invoicing.Button.Submit' })}
        </Button>
      </div>
    </div>
  )
}
